import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import isEmpty from 'lodash.isempty';
import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import ClientForm from './ClientForm';
import SecureNewClient from './SecureNewClient';
import VerifyExistingClient from './VerifyExistingClient';
import { useApplicationStore } from './applicationStore';

const SecureAccount = () => {
	const { getClient, skipAccountCreation, isExistingClient, program } =
		useApplicationStore();
	const [isExistingConfirmed, setExistingConfirmed] = useState(false);
	const [isStubbedAccountValid, setIsStubbedAccountValid] = useState(false);
	const [updateAppStore, setUpdateAppStore] = useState(false);
	const navigate = useNavigate();
	const clientQuestionsQuery = useQuery({
		queryKey: ['clientQuestions', getClient().id],
		queryFn: async () => {
			const { data } = await axios.get(
				`/requests/client-security-questions/${getClient().id}`,
			);
			return data;
		},
		enabled: Boolean(getClient()?.id),
	});

	if (!getClient().name_last && !getClient().name_first) {
		return <Navigate to="/newApplication/profile" replace />;
	}

	const isStubbedAccount =
		isEmpty(getClient().last_4_ssn) &&
		isEmpty(getClient().username) &&
		clientQuestionsQuery?.data?.length === 0;

	const handleNext = () => {
		if (isStubbedAccountValid && !isExistingConfirmed) {
			setUpdateAppStore(true);
			setExistingConfirmed(true);
		} else {
			if (program) {
				navigate('/newApplication/confirm');
			} else {
				navigate('/newApplication/search');
			}
		}
	};

	return (
		<>
			<h1>Secure Profile</h1>
			<div className="secure-account">
				{isExistingClient && !isStubbedAccount ? (
					<>
						{isExistingConfirmed ? (
							<>
								<p>
									<em>
										Confirm profile contact information.{' '}
										<span className="text-error">*</span> Indicates required
										field
									</em>
								</p>
								<div className="existing-client-form">
									<ClientForm onlyProfile />
								</div>
							</>
						) : (
							<VerifyExistingClient
								isExistingConfirmed={isExistingConfirmed}
								setExistingConfirmed={setExistingConfirmed}
							/>
						)}
					</>
				) : (
					<SecureNewClient
						onValidated={setIsStubbedAccountValid}
						updateAppStore={updateAppStore}
					/>
				)}
			</div>
			<div className="grid grid-cols-2">
				<div></div>
				<div className="flex justify-end">
					{(isExistingConfirmed || !isExistingClient || isStubbedAccount) && (
						<button
							className="btn btn-primary btn-wide"
							disabled={
								!skipAccountCreation &&
								((isStubbedAccount && !isStubbedAccountValid) ||
									(!isExistingClient && !isStubbedAccountValid))
							}
							onClick={handleNext}
						>
							Next
						</button>
					)}
				</div>
			</div>
		</>
	);
};

export default SecureAccount;
